import type { CRMProps } from "@/components/atomic-crm/root/CRM";

export const echoflicksCrmConfig = {
  title: "Echoflicks CRM",
  darkModeLogo: "./logos/logo_echoflicks_icon.svg",
  lightModeLogo: "./logos/logo_echoflicks_icon.svg",
  dealCategories: [
    { value: "creator-campaign", label: "Creator campaign" },
    { value: "video-production", label: "Video production" },
    { value: "content-licensing", label: "Content licensing" },
    { value: "platform-integration", label: "Platform integration" },
    { value: "other", label: "Other" },
  ],
  taskTypes: [
    { value: "none", label: "None" },
    { value: "whatsapp", label: "WhatsApp" },
    { value: "creator-call", label: "Creator call" },
    { value: "demo", label: "Demo" },
    { value: "follow-up", label: "Follow-up" },
    { value: "contract", label: "Contract" },
    { value: "launch", label: "Launch" },
  ],
  disableTelemetry: true,
} satisfies Partial<CRMProps>;
